var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LowerB',{staticClass:"banner-design-elements",staticStyle:{"right":"50px","top":"-20px","opacity":"0.5"},attrs:{"width":"200"}}),_c('Leaf',{staticClass:"banner-design-elements",staticStyle:{"right":"200px","top":"10px","opacity":"0.4"},attrs:{"width":"100","stroke":"","stroke-width":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }